import { ReportService } from './../service/report.service';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ImageClassification } from './../model/imageClassification.model';
import { SubscriptionService } from './../service/subscription.service';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  ChangeDetectorRef,
  AfterViewInit,
  TemplateRef,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router, NavigationExtras } from '@angular/router';
import { Tchek } from '../model/tchek';
import { TchekOldService } from '../service/tchek-old.service';
import { NotificationService } from '../service/notification.service';
import * as screenfull from 'screenfull';
import { ParseFunctionService } from '../service/parsefunction.service';
import { ParseService } from '../service/parse.service';
import { TraceService } from '../service/trace.service';
import { NotificationsService } from 'angular2-notifications';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { CanvasComponent, CanvasState } from '../element/canvas/canvas.component';
import 'parse';
const parse: typeof Parse = require('parse');
import { RoiService } from '../service/roi.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { AwsService } from '../service/aws.service';
import { Globals } from '../GlobalsExport';
import { Camera } from '../model/camera';
import { TchekUser } from '../model/user';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FavoritePictureFilters } from '../model/detail';
import { findIndex, map } from 'rxjs/operators';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Observable, Subscription } from 'rxjs';
import { bool } from 'aws-sdk/clients/signer';
import { AnnotationService } from '../service/annotation.service';
import { Damage, DamageAnalysis, ModelIa } from '../model/damage.model';
import { from } from 'rxjs/observable/from';
import { DamageService } from '../service/damage.service';
import { ParametersService } from '../service/parameters.service';
import { Tchekb, TchekImages, TchekType } from '../model/tchekb.model';
import { ImagesService } from '../service/images.service';
import { TchekImage } from '../model/image';
import { ToastService } from '../service/toast.service';
import axios from 'axios'
declare const $: any;

enum ActiveCanvas {
  LEFT,
  RIGHT
}

export enum CanvasParameter {
  GAMMA,
  CONTRAST,
  SATURATION,
  INVERSION,
  MIRROR,
  OFFSET
}

class ListCamera {
  array: Array<Camera>;
  constructor(cameras: Array<Camera>) {
    this.array = cameras;
  }

  atIndex(index: number | string): Camera {
    return this.array[(typeof index === 'string') ? parseInt(index, 10) : index];
  }

  get(cameraName: number | string): Camera {
    return this.array.find(camera => (camera.name === cameraName));
  }

  setMiniPicture(cameraName: string, url: string): boolean {
    const index = this.array.findIndex(c => (c.name === cameraName));
    if (index > -1) {
      this.array[index].miniPicture = url;
      return true;
    } else
      return false;
  }

  sort() {
    this.array = this.array.sort(function (a, b) {
      if (a && b)
        return a.orderCam - b.orderCam;
    });
  }
}

@Component({
  selector: 'app-animation',
  templateUrl: './animation.component.html',
  styleUrls: ['./animation.component.less'],
  animations: [
    trigger('hideShowAnimator', [
      state('true', style({ opacity: 1 })),
      state('false', style({ opacity: 0.55 })),
      transition('0 => 1', animate('.5s')),
      transition('1 => 0', animate('.9s'))
    ])
  ]
})


export class AnimationComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  static _scrollMiniaturesStepPx = 160; // Number of pixel to move left or right when clicking camera row's arrows
  tchekType = TchekType;
  currentMode = 'video'
  currentImage: TchekImage
  cp = CanvasParameter;
  @ViewChild('animationRange') animationRange: ElementRef;
  @ViewChild('canvas0') canvas0: CanvasComponent;
  @ViewChild('canvas1') canvas1: CanvasComponent;
  @ViewChild('favFiltersModal') favFiltersModal: TemplateRef<any>;
  favFiltersModalRef: NgbModalRef;
  filters = ['gamma', 'contrast', 'saturation', 'invert'];
  vehicleId: string;
  matrice = Array<any>();
  camName: string;
  fastComp: string
  isPercent: boolean = true
  tchek: TchekImages;
  forValidation = false;
  isAnnotated = false;

  tcheks = Array<Tchek>();
  newTcheks = Array<Tchek>();
  selectedPhoto: string;
  animations = Array<any>();
  animationTotalPictures: number;
  windowWidth = 100;
  isLocal = false;
  isFull = false;
  hoverImg = 0;
  bubble = 0;
  extension = '.jpg';
  isSelected = false;
  canvasFullWidth = 400;
  isImageHd = false
  canvasFullHeight = 400;
  t: any;
  firstImg = 0;
  baseURLPicture: string;
  screenW: number;
  screenH: number;
  isIos: boolean;
  showCam = false;
  showFilter = false;
  toggleEdit = false;
  logoURL: string;
  date: Date;
  hideShowAnimator = false;
  isVideoHidden: boolean;
  fcanvas: any;
  mobile = false;
  showCamLock = false;
  listCamera: ListCamera;
  isLoadingPicture = true;
  isSliding = false;
  user: TchekUser;
  camSelected = 0;
  roiCount = 0;
  savedRois = [];
  shiftKey = false;
  altKey = false;
  ctrlKey = false;
  circle: any;
  fvideo: any;
  fimage: any;
  finversion = [false, false];
  fmirror = [false, false];
  fgamma = [1, 1];
  fcontrast = [0, 0];
  fsaturation = [0, 0];
  offsets = [0, 0];
  activeCanvas = ActiveCanvas.LEFT;
  way: boolean;
  uploadHDPictures = true;
  diskFolderName: string;
  videoNumber: number;
  compareMode = false;
  revertCamera: boolean
  tunnel: boolean
  countFolders: number = 0
  @ViewChild('popover') popover: NgbPopover;
  @ViewChild('popoverIa') popoverIa: NgbPopover;

  tchekCompareDamages: Damage[]
  selectedCompareDamage: Damage
  tchekId: string;

  device: string;
  deviceId: string;
  ipMachine: string

  ModelIa: ModelIa[]
  imageSelectedModel: string = 'Original'
  iaRunningInspection: boolean = false
  selectedModelIa: string

  // TODO: create a class for this
  roisMatrix = {
    rois: undefined, // Will contain an array of ParseObjects
    pictureHasRois: function (folder, pictureNumber): boolean {
      if (!this.rois) {
        console.error('Calling pictureHasRois() while array is undefined');
        return false;
      }
      // console.log('roisMatrix : ', this.rois);
      for (let i = 0; i < this.rois.length; i++) {
        // console.log(this.rois[i].get('folder'), '==', folder, ' && ', this.rois[i].get('picture'), '==', pictureNumber, '?', this.rois[i].get('folder') == folder && this.rois[i].get('picture') == pictureNumber);
        if (
          this.rois[i].get('folder') == folder &&
          this.rois[i].get('picture') == pictureNumber
        )
          return true;
      }
      return false;
    },
    findById: function (parseId): any {
      if (!this.rois) {
        console.error('Calling findById() while array is undefined');
        return undefined;
      }
      for (let i = 0; i < this.rois.length; i++) {
        if (this.rois[i].id === parseId) return this.rois[i];
      }
      return false;
    },
    getIndexById: function (parseId): any {
      if (!this.rois) {
        console.error('Calling getIndexById() while array is undefined');
        return undefined;
      }
      for (let i = 0; i < this.rois.length; i++) {
        if (this.rois[i].id === parseId) return i;
      }
      return false;
    },
    updateMovedRoi: function (parseId, newX, newY): void {
      if (!this.rois) {
        console.error('Calling updateMovedRoi() while array is undefined');
        return undefined;
      }
      for (let i = 0; i < this.rois.length; i++) {
        if (this.rois[i].id === parseId) {
          this.rois[i].set('centerX', newX);
          this.rois[i].set('centerY', newY);
          return;
        }
      }
    }
  };
  favMatrix = {
    favorites: [],
    isFaved: function (folder, picture): boolean {
      for (let i = 0; i < this.favorites.length; i++) {
        if (
          this.favorites[i].folder === folder &&
          this.favorites[i].picture === picture
        )
          return true;
      }
      return false;
    },
    set: function (folder, picture): void {
      this.favorites.push({ folder: folder, picture: picture });
    },
    unset: function (folder, picture): void {
      for (let i = 0; i < this.favorites.length; i++) {
        if (
          this.favorites[i].folder === folder &&
          this.favorites[i].picture === picture
        )
          this.favorites.splice(i, 1);
      }
    }
  };
  canvasCurrentlyEditing: number;
  isSuperAdmin = false;
  comparisonActive: boolean;
  subscription: Subscription;
  isPOVSeen = new Array(14); // Increment this value if it can be exceeded by number of cams
  routerNumberPic = 0;
  tchekIdComparison: string;
  // TODO: rename routerNumberPic to smth lik routerPicturePercent
  private allObs: Observable<{ g: string, c: string, s: string, i: string, m: string }>;
  public _defaultLogoPath = '../../../assets/images/your-logo.png';
  public toggleAnnotate: boolean;
  listDamages = []// AnnotationService._damageTypes;
  listPieces = []//AnnotationService._partTypes;
  annotationMode = 0;
  tchekReady = false;
  minProbVehicle = -1;
  images: { model: string, images: TchekImage[] }[]
  picId: string
  countEndClassification

  insideClassificationImage = false

  constructor(
    private http: HttpClient,
    private _tchekService: TchekOldService,
    public _imagesService: ImagesService,
    private _router: Router,
    private _subscriptionService: SubscriptionService,
    private _damageService: DamageService,
    private _route: ActivatedRoute,
    private _location: Location,
    private _notificationService: NotificationService,
    private _parseFunction: ParseFunctionService,
    private _reportservice: ReportService,
    private parseService: ParseService,
    public _roiService: RoiService,
    private awsService: AwsService,
    private _toastService: ToastService,
    private _traceService: TraceService,
    private readonly _parametersService: ParametersService,
    private globals: Globals,
    private notif: NotificationsService,
    private i18n: I18n,
    private _zone: NgZone,
    private _cd: ChangeDetectorRef,
    private _modalService: NgbModal,
    private _annotationService: AnnotationService,
  ) {

    this.tunnel = this.awsService.tunnel
    // this.logoURL = parse.User.current().get('image').url();
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    this.user = this._parseFunction.getUser(parse.User.current());
    this.logoURL = this._parseFunction.getCompany(parse.User.current().get('companyPtr')).logo;

    if (this.isSuperAdmin && !environment.isLocal) {
      this._damageService.getModelIa().then(res => { this.ModelIa = res; this.selectedModelIa = this.ModelIa[0].name })
    }
    let style = this._parametersService.getAll().style
    if (style) {
      if (style.gamma !== undefined)
        this.fgamma = [style.gamma, style.gamma]
      if (style.contrast !== undefined)
        this.fcontrast = [style.contrast, style.contrast]
      if (style.saturation !== undefined)
        this.fsaturation = [style.saturation, style.saturation]
    }
    // Getting route paramaters
    this._route.params.subscribe((params: Params) => {

      this.camName = params['camName'];
      this.tchekId = params['id'];
      this.routerNumberPic = params['picNum'] ? Number(params['picNum']) : 0;
      this.videoNumber = params['picNum'] ? Number(params['picNum']) : 0;

      if (this.tchek && this.tchek.picturesSelected && this.tchek.picturesSelected["thumbnail"]) {
        if (this.camName === undefined) this.camName = this.tchek.picturesSelected["thumbnail"].camera
        if (this.routerNumberPic === undefined) this.routerNumberPic = this.tchek.picturesSelected["thumbnail"].picture
      } else {
        if (this.camName === undefined) this.camName = '1'
        if (this.routerNumberPic === undefined) this.routerNumberPic = 1
      }

      if (this._router.url.includes('viewer')) {
        this.currentMode = 'image'
        this.picId = params['picId']
        if (this.tchek && this.tchek.images && this.tchek.images.length > 0) {
          let index = this.tchek.images.findIndex(img => { return img.id === this.picId })
          if (index !== -1)
            this.currentImage = this.tchek.images[index]
          else this.currentImage = this.tchek.images[0]
          this.switchToImage(this.currentImage)
        }
      }

      if (this._router.url.includes('underbody')) {
        this.currentMode = 'underbody'
      }

      if (this._router.url.includes('classificationImage')) {
        this.isLoadingPicture = false;
        this.currentMode = 'image'
        this.picId = params['picId']
        this.insideClassificationImage = true

        // count end classification  
        this._imagesService.countEndClassificationImages().then(r => { this.countEndClassification = r; })

        // subscribe to imageclassification
        const query = new parse.Query('ImageClassification');
        this._subscriptionService.sub(query, 'ImageClassification');
        this._subscriptionService.listen('ImageClassification', 'create', async data => {
          let newcla = new ImageClassification(data)
          console.log('new classification image', newcla);
          await this._imagesService.getClassificationImages()
          // remove image from list if exist  : ?
          this._imagesService.imageList = this._imagesService.imageList.filter(i => { return i.id !== newcla.imagePtr.id })
          if (this.currentImage.id === newcla.imagePtr.id) {
            // go to next image
            this.currentImage = this._imagesService.imageList[0]
            this.tchekId = this.currentImage.tchekPtr.id
            this.images = [{ model: 'Original ', images: [this.currentImage] }]
            this.tchek = new TchekImages(this.currentImage.tchekPtr.getParseInstance(), this.images[0].images);
            this.switchToImage(this.currentImage)
          }
        });

        const queryI = new parse.Query('Images');
        this._subscriptionService.sub(queryI, 'Images');
        this._subscriptionService.listen('Images', 'update', async data => {
          let image = new TchekImage(data)
          if (image.classification)
            this.countEndClassification++; // add +1 to count
        })

        this._imagesService.getClassificationImages().then(images => {
          this.currentImage = this._imagesService.imageList[0]
          this.tchekId = this.currentImage.tchekPtr.id
          this.images = [{ model: 'Original ', images: [this.currentImage] }]
          this.tchek = new TchekImages(this.currentImage.tchekPtr.getParseInstance(), this.images[0].images);
          this.switchToImage(this.currentImage)
        })

        this.subscription = this._imagesService.classificationImagesObs.subscribe((id) => {
          if (this.currentImage.id === id) {
            this._imagesService.imageList = this._imagesService.imageList.filter(i => { return i.id !== id })
            // go to next image
            this.currentImage = this._imagesService.imageList[0]
            this.tchekId = this.currentImage.tchekPtr.id
            this.images = [{ model: 'Original ', images: [this.currentImage] }]
            this.tchek = new TchekImages(this.currentImage.tchekPtr.getParseInstance(), this.images[0].images);
            this.switchToImage(this.currentImage)
          }
        })

        // this.tchekId = 'VATtjUkm1t'
        // if (this.tchek && this.tchek.images && this.tchek.images.length > 0) {
        //   let index = this.tchek.images.findIndex(img => { return img.id === this.picId })
        //   if (index !== -1)
        //     this.currentImage = this.tchek.images[index]
        //   else this.currentImage = this.tchek.images[0]
        //   this.switchToImage(this.currentImage)
        // }
      }
    });
    this._route.queryParams.subscribe((params: Params) => {
      // console.log('Route rcv new params', params);
      var stringValue = params['isPercent'] ? params['isPercent'] : true;
      this.isPercent = (/true/i).test(stringValue)

      this.fastComp = params['fastComp']
    });
    this.listPieces = _annotationService._partTypes.sort()
    this.listDamages = _annotationService._damageTypes.sort()

    this._notificationService.currentNewTcheks.subscribe(
      newTcheks => (this.newTcheks = newTcheks)
    );


    this.canvasCurrentlyEditing = 0;
    this.comparisonActive = false;
    this.listCamera = new ListCamera([]);
    this.toggleAnnotate = false;
    // this.tchek = { get: function () { return false; } };
    this.isLocal = environment.isLocal;

    // Initializing all cameras to 'not seen'
    for (let i = 0; i < this.isPOVSeen.length; i++)
      this.isPOVSeen[i] = false;

  }

  reloadImagesSkip() {
    this._imagesService.getClassificationImages(true).then(i => {
      this.currentImage = this._imagesService.imageList[0]
      this.tchekId = this.currentImage.tchekPtr.id
      this.images = [{ model: 'Original ', images: [this.currentImage] }]
      this.tchek = new TchekImages(this.currentImage.tchekPtr.getParseInstance(), this.images[0].images);
      this.switchToImage(this.currentImage)
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }

  public set gamma(v: number) {
    this.fgamma[this.activeCanvas] = v;
    this.updateUrlWithFilters();
  }
  public set contrast(v: number) {
    this.fcontrast[this.activeCanvas] = v;
    this.updateUrlWithFilters();
  }
  public set saturation(v: number) {
    this.fsaturation[this.activeCanvas] = v;
    this.updateUrlWithFilters();
  }
  public set inversion(v: boolean) {
    this.finversion[this.activeCanvas] = v;
    this.updateUrlWithFilters();
  }
  public set mirror(v: boolean) {
    this.fmirror[this.activeCanvas] = v;
    this.updateUrlWithFilters();
  }
  public get gamma(): number {
    return this.fgamma[this.activeCanvas];
  }
  public get contrast(): number {
    return this.fcontrast[this.activeCanvas];
  }
  public get saturation(): number {
    return this.fsaturation[this.activeCanvas];
  }
  public get inversion(): boolean {
    return this.finversion[this.activeCanvas];
  }
  public set offset(v: number) {
    console.log('offset : ', v, this.activeCanvas);
    this.offsets[1] = v; // set 1 
  }
  public get offset(): number {
    return this.offsets[1];// set 1 
  }

  getCanvasParameter(parameter: CanvasParameter, canvasId?: number): number | boolean {
    if (canvasId === undefined)
      canvasId = this.activeCanvas;

    switch (parameter) {
      case CanvasParameter.GAMMA:
        return this.fgamma[canvasId];
      case CanvasParameter.CONTRAST:
        return this.fcontrast[canvasId];
      case CanvasParameter.SATURATION:
        return this.fsaturation[canvasId];
      case CanvasParameter.INVERSION:
        return this.finversion[canvasId];
      case CanvasParameter.OFFSET:
        return this.offsets[canvasId];
      case CanvasParameter.MIRROR:
        return this.fmirror[canvasId];
      default:
        console.error('Invalid parameter', parameter, ' for getCanvasParameter()');
        return undefined;
    }
  }

  updateUrlWithFilters() {
    const routeExtras = {
      queryParams: {
        gamma: this.gamma,
        contrast: this.contrast,
        saturation: this.saturation,
        inversion: this.inversion ? 1 : 0
      }
    } as NavigationExtras;
    // Changing URL address
    if (this.currentMode === 'video')
      this._router.navigate(['/player', this.tchekId, this.camName, this.routerNumberPic], routeExtras);
    else if (this.insideClassificationImage !== true)
      this._router.navigate(['/viewer', this.tchekId, this.currentImage.id], routeExtras);
  }

  getCanvasNumberPic(canvasId: number) {
    if (canvasId === 1 && this.selectedCompareDamage && this.selectedCompareDamage.roiPtr) {
      let currentRoi = this.selectedCompareDamage.roiPtr.folderPtr.toPercentage(this.selectedCompareDamage.roiPtr.picture)
      let current = parseInt(this.routerNumberPic.toString(), 10)
      this.offsets[1] = currentRoi - current
      //this._roiService.setHighlightedDamageCompare(undefined)
      this.selectedCompareDamage = undefined
      console.log('damage select for go to : ', this.offsets[1], current, currentRoi);
    }
    const numberPic = (typeof this.routerNumberPic === 'string' ? parseInt(this.routerNumberPic, 10) : this.routerNumberPic) +
      this.offsets[canvasId];
    if (numberPic < 0)
      return 0;
    else if (numberPic > 99)
      return 99;
    else
      return numberPic;
  }

  getCanvasNumberVideo(canvasId: number) {
    const numberVid = (typeof this.videoNumber === 'string' ? parseInt(this.videoNumber, 10) : this.videoNumber) +
      this.offsets[canvasId];
    //  console.log('number video : ', numberVid);
    if (numberVid < 0)
      return 0;
    else if (numberVid > 99)
      return 99;
    else
      return numberVid;
  }

  ngOnInit() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }

    // Observing URL query parameters
    const gammaObs = this._route.queryParamMap.pipe(map(params => params.get('gamma') || undefined));
    const contrastObs = this._route.queryParamMap.pipe(map(params => params.get('contrast') || undefined));
    const saturationObs = this._route.queryParamMap.pipe(map(params => params.get('saturation') || undefined));
    const inversionObs = this._route.queryParamMap.pipe(map(params => params.get('inversion') || undefined));
    const mirrorObs = this._route.queryParamMap.pipe(map(params => params.get('mirror') || undefined));
    this.allObs = combineLatest(gammaObs, contrastObs, saturationObs, inversionObs, mirrorObs,
      (g, c, s, i, m) => ({ g, c, s, i, m }));

    // Subscribing to URL parameters
    this.allObs.subscribe(values => {
      if (values.g !== undefined && values.c !== undefined && values.s !== undefined && values.i !== undefined && values.m !== undefined) {
        this.gamma = parseFloat(values.g);
        this.contrast = parseFloat(values.c);
        this.saturation = parseFloat(values.s);
        this.inversion = values.i === '1';
        this.mirror = values.m === '1';
      }
    });

    this.isFull =
      $(document).webkitIsFullScreen ||
      $(document).fullScreen ||
      $(document).mozFullScreen;

    // ;

    this.isVideoHidden = !this.mobile;
    if (this.mobile) this.hideShowAnimator = true;

    this.toggleEdit = false;

    // Handler for camera lock on double click
    $('#cameraButton').dblclick(e => {
      e.preventDefault();
      this.showCamLock = !this.showCamLock;
      this._traceService.saveTrace(
        this.tchekId,
        'double click cam in animation view'
      );
    });

    // Handler to prevent text selection on double click
    $('#cameraButtonText').dblclick(e => {
      e.preventDefault();
      if (window.getSelection) {
        const sel = window.getSelection();
        sel.removeAllRanges();
      }
      //console.log('Prevented text selection');
    });

    // console.log('Animation getRoi')
    this._roiService.getTchekRois(this.tchekId).then(
      roisRetrieved => {
        this.roisMatrix.rois = roisRetrieved;
        //    console.log('roi matrix ', this.roisMatrix.rois)
      },
      error => console.error('Could not retrieve all ROIs')
    );


    // Initialize cameras
    if (this.insideClassificationImage !== true)
      this._tchekService.getTchek(this.tchekId).then(tchek => {
        this._imagesService.getByTchek(this.tchekId).then(async images => {
           this.images = images

		   try {
			   if([4,5].includes(tchek.get('type')) || (tchek.get('type')  === 0 && this.isSuperAdmin )){
				 let report = await this._roiService.getReport(tchek)
				   let i = report.data.images 
				 console.log(i)
				 this._roiService.imagesF = {tchekId : tchek.id, images : i}
				 this.images.map(im => {
					 im.images.map(ii => {
						 let index = i.findIndex(f => { return f.id === ii.id})
						 ii.file = this._roiService.parseFileObj(i[index].url);
					 })
				 })}
		   } catch (error) {
			console.log(error)
		   }


          this.tchek = new TchekImages(tchek, this.images[0].images);

          if ([4,5,2].includes(this.tchek.type)) {
            this.currentMode = 'image'
            this.currentImage = this.tchek.images[0]
          } else {
            if (this.tchek && this.tchek.picturesSelected && this.tchek.picturesSelected["thumbnail"]) {
              if (this.camName === undefined) this.camName = this.tchek.picturesSelected["thumbnail"].camera
              if (this.routerNumberPic === undefined) this.routerNumberPic = this.tchek.picturesSelected["thumbnail"].picture
            } else {
              if (this.camName === undefined) this.camName = '1'
              if (this.routerNumberPic === undefined) this.routerNumberPic = 1
            }
          }

          if (this.currentMode === 'image') {
            let index = -1
            if (this.picId)
              index = this.tchek.images.findIndex(img => { return img.id === this.picId })
            if (index !== -1)
              this.currentImage = this.tchek.images[index]
            this.switchToImage(this.currentImage)
          }


          // console.log('tchek set ',tchek);
          this.isAnnotated = this.tchek.isAnnotated;
          this.forValidation = this.tchek.forValidation;
          this.way = this.tchek.way;
          if (environment.isLocal) {
            this.device = this.tchek.devicePtr.id;
            if (this.tchek.isHDLocal !== undefined) {
              this.uploadHDPictures = this.tchek.isHDLocal;
            } else {
              this.uploadHDPictures = false;
            }
          } else if (this.tchek.type !== 4 || this.isSuperAdmin) {
            this.device = this.tchek.devicePtr.id;
            if (this.tchek.uploadHDPictures !== undefined) {
              this.uploadHDPictures = this.tchek.uploadHDPictures;
            } else {
              this.uploadHDPictures = false;
            }
          }

          this.vehicleId = this.tchek.vehiclePtr.id;
          this.diskFolderName = this.tchek.path;
          this.generateCameras(tchek.way);
          this.tchekReady = true;

          if (this.fastComp) this.openComparison(this.fastComp)

        });
      })

    $(() => {
      // <- and -> to move POVs
      $(document).on('keydown', event => {
        const key = event.keyCode;

        switch (key) {
          case 37:
            $('.animator').scrollLeft($('.animator').scrollLeft() + AnimationComponent._scrollMiniaturesStepPx);
            break;

          case 39:
            $('.animator').scrollLeft($('.animator').scrollLeft() - AnimationComponent._scrollMiniaturesStepPx);
            break;

          default:
            break;
        }
      });
    });

  }

  touch(e) {
    console.log(e)
    if (e.type === 'mouseup' || e.type === 'touchend') {
      if (this.currentMode === 'video') {
        this.isSliding = false;
        if (!this.showCamLock) {
          this.showCam = false;
        }
        // console.log($(e.target).val() + '/ 100 *' + this.listCamera.get(this.camName).totalPictures + ' - 1 =' + this.routerNumberPic, 'camName:' + this.camName, this.listCamera.get(this.camName));
        this.regenerateCameras();
        // Changing URL address
        if (this.routerNumberPic === $(e.target).val()) {
          this._router.navigate(['/player', this.tchekId, this.camName, $(e.target).val()]);
          this.routerNumberPic = parseInt($(e.target).val(), 10) + .00000001;
        } else {
          this._router.navigate(['/player', this.tchekId, this.camName, $(e.target).val()]);
          this.routerNumberPic = $(e.target).val();
        }
      }
    } else if (e.type === 'mousedown' || e.type === 'touchstart') {
      if (this.currentMode === 'video')
        this.isSliding = true;
    }
  }

  ngAfterViewInit() {
    // Initialize annotation damage
    this.setDamageForAnnotation(undefined);
  }

  scrollRight() {
    $('.animator').scrollLeft($('.animator').scrollLeft() + AnimationComponent._scrollMiniaturesStepPx);
    /* if (Number(this.bubble) < 100) {
      this.bubble = Number(this.bubble) + 1;
      this.seekThroughVideo(this.bubble);
    } */
  }

  scrollLeft() {
    $('.animator').scrollLeft($('.animator').scrollLeft() - AnimationComponent._scrollMiniaturesStepPx);
    /* if (Number(this.bubble) > 0) {
      this.bubble = Number(this.bubble) - 1;
      this.seekThroughVideo(this.bubble);
    } */
  }
  tchekIsAnnotated() {
    if (this.user.canAnnotate) {
      this.isAnnotated = !this.isAnnotated;
      this.tchek.isAnnotated = this.isAnnotated;
      //  this.tchek.save();
    }
  }
  tchekForValidation() {
    if (this.user.canAnnotate) {
      this.forValidation = !this.forValidation;
      this.tchek.forValidation = this.forValidation;

      //finir ici
      this.tchek.getParseInstance().save();
    }
  }
  pictureForValidation() {
    if (this.user.canAnnotate) {
      const _annotation = parse.Object.extend('Annotation');
      const annotation = new _annotation();
      annotation.set('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: this.tchekId
      });
      annotation.set('type', 3);
      annotation.set('sequence', parseInt(this.toPictureName(this.routerNumberPic), 10));
      annotation.set('folder', this.camName);
      annotation.set("userPtr", parse.User.current())
      /*
      roiToSave.set('toSync', true);
      const acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      acl.setRoleReadAccess(parse.User.current().get('roleCompany'), true);
      acl.setRoleWriteAccess(parse.User.current().get('roleCompany'), true);
      roiToSave.setACL(acl); */
      annotation.save().then((savedRoi) => {
        //console.log('success', savedRoi);
      }, (error) => {
        console.error('Failed to create new ROI, with error: ' + error.code + ' ' + error.message);
        console.warn(error);
      });
    }
  }


  switchToVideo() {
    this.currentMode = 'video'
    if (this.tchek && this.tchek.picturesSelected && this.tchek.picturesSelected["thumbnail"]) {
      if (this.camName === undefined) this.camName = this.tchek.picturesSelected["thumbnail"].camera
      if (this.routerNumberPic === undefined) this.routerNumberPic = this.tchek.picturesSelected["thumbnail"].picture
    } else {
      if (this.camName === undefined) this.camName = '1'
      if (this.routerNumberPic === undefined) this.routerNumberPic = 1
    }
    this.toggleAnnotate = false;
    this.toggleEdit = false
    this._router.navigate([
      '/player',
      this.tchekId,
      this.camName,
      this.routerNumberPic
    ]);
  }

  notInplayerImages(): boolean {
    let imagenotinPlayer = true
    if (this.currentMode !== 'video' && this.tchek.type < 2)
      imagenotinPlayer = false
    return imagenotinPlayer
  }

  switchToImage(image?: TchekImage) {
    console.log("switch##########");
    this.currentMode = 'image'
    this.currentImage = undefined
    if (image !== undefined)
      this.currentImage = image
    else
      this.currentImage = this.tchek.images[0]

    if (this.currentMode === 'video')
      if (this.tchek && this.tchek.picturesSelected && this.tchek.picturesSelected["thumbnail"]) {
        if (this.camName === undefined) this.camName = this.tchek.picturesSelected["thumbnail"].camera
        if (this.routerNumberPic === undefined) this.routerNumberPic = this.tchek.picturesSelected["thumbnail"].picture
      } else {
        if (this.camName === undefined) this.camName = '1'
        if (this.routerNumberPic === undefined) this.routerNumberPic = 1
      }

    if (this.currentImage === undefined) {
      this._toastService.toastOpen(undefined, this.i18n({
        id: 'noImage',
        value: "Pas d'images sur ce tchek",
        description: 'Pas dimages sur ce tchek',
        meaning: "animation"
      }), 'error')
      this.isLoadingPicture = false;
    } else if (this.insideClassificationImage !== true)
      this._router.navigate([
        '/viewer',
        this.tchekId,
        this.currentImage.id
      ]);

    this._imagesService.runReloadImages(this.currentImage)
  }

  switchToUnderbody() {
    this.currentMode = 'underbody'
    this._router.navigate([
      '/underbody',
      this.tchekId
    ]);
  }


  resetSize() {
    if (this.mobile) {
      this.canvasFullWidth =
        (($('#container-full')[0].offsetHeight -
          $('#anim-footer')[0].offsetHeight) *
          800) /
        537;
      this.canvasFullHeight =
        $('#container-full')[0].offsetHeight -
        $('#anim-footer')[0].offsetHeight;
    }
  }

  showAnimation() {
    this.hideShowAnimator = true;
  }

  statusReport = 0
  existAPi = false
  async pdfApi() {
    if (this.existAPi) return
    try {
      let res = await parse.Cloud.run('pdfApi',
        {
          tchekId: this.tchekId
        })
      this.existAPi = true

      console.log('pdf api', res);
      const query = new parse.Query('Report');
      query.equalTo('objectId', res.reportId);
      this._subscriptionService.sub(query, 'reportProgress');
      this._subscriptionService.listen('reportProgress', 'update', r => {
        this.statusReport = r.get('progress')
        if (r.get('progress') === 100) {
          this._subscriptionService.unsub('reportProgress');
          this.existAPi = false
          this.statusReport = 0
          const downloadAnchor = document.createElement('a');
          downloadAnchor.setAttribute('href', res.fileUrl);
          downloadAnchor.setAttribute('download', res.fileName);
          downloadAnchor.setAttribute('target', '_blank');
          downloadAnchor.style.display = 'none';
          document.body.appendChild(downloadAnchor);
          downloadAnchor.click();
          document.body.removeChild(downloadAnchor);
        }
      })
    } catch (error) {
      console.log(error);
    }
  }

  hideAnimation() {
    if (this.mobile) this.hideShowAnimator = true;
    else this.hideShowAnimator = false;
  }

  // Méthode de retour à la page précédente
  dismissSlider() {
    // Reactivate scrollbars
    $('body').css('overflow', 'auto');
    // Modifying route to detail view
    const nextURL = '/tchek/detail/' + this.vehicleId + '/' + this.tchekId;
    // Changing URL address
    this._router.navigateByUrl(nextURL);
  }

  // Methode pour set l'image a fullScreen
  setFull() {
    // Initially, do not go into full screen
    if (screenfull.enabled) {
      this.isFull = !this.isFull;
      screenfull.toggle();
      this.canvasFullWidth = (window.screen.height * 800) / 537;
      this.canvasFullHeight = window.screen.height;
      $('.canvas-container').css('visibility', 'visible');
      console.log('canvas full height ', this.canvasFullHeight)
    }
  }

  changeModelIa(event) {
    console.log('changeModelIa : ', event)
    if (event.model === 'Original')
      this.tchek.images.forEach(i => { i.child = undefined })
    else {
      let iaRes = this.images[this.images.findIndex(i => i.model === event.model)].images
      iaRes.forEach(iaR => {
        let index = this.tchek.images.findIndex(i => { return i.id === iaR.parentPtr.id })
        if (index !== -1)
          this.tchek.images[index].child = iaR
      })
    }
    this.switchToImage(this.tchek.images[this.tchek.images.findIndex(i => { return i.id === this.currentImage.id })])
  }

  getSelectedModelIaDesc(): string {
    let index = this.ModelIa.findIndex(m => m.name === this.selectedModelIa)
    if (this.selectedModelIa && index !== -1)
      return this.ModelIa[index].description
    else
      return undefined
  }

  inspectTchek() {
    this.popoverIa.close()
    if (this.iaRunningInspection) return
    this.iaRunningInspection = true
    this._imagesService.runDetectionTchekImage(this.tchek.id, this.selectedModelIa).then(res => {
      console.log(res);
      if (res.error) {
        this.iaRunningInspection = false
        this._toastService.toastOpen(undefined, this.i18n({
          id: 'noImage',
          value: 'Pas dimages sur ce tchek',
          description: 'Pas dimages sur ce tchek',
          meaning: "animation"
        }), 'error')
        return
      }
      if (this._imagesService.createDamage)
        this._parametersService.damageFilterEdit()
      this._imagesService.getByTchek(this.tchekId).then(images => {
        this.iaRunningInspection = false
        this.images = images
      })
    })
  }

  changeCanvasSize() {
    console.log('change size');
    if (this.mobile) {
      this.canvasFullWidth = $('#container-full')[0].offsetWidth;
    } else
      this.canvasFullWidth =
        (($('#container-full')[0].offsetHeight -
          $('#anim-footer')[0].offsetHeight) *
          800) /
        537;
    this.canvasFullHeight =
      $('#container-full')[0].offsetHeight - $('#anim-footer')[0].offsetHeight - $('#imagesRow')[0].offsetHeight;
    console.log('canvas full height cahnge size ', this.canvasFullHeight)
  }

  newCanvasStateHandler(event) {
    switch (event) {
      case CanvasState.LoadingPicture:
      case CanvasState.Initializing:
        this.isLoadingPicture = true;
        break;
      default:
        this.isLoadingPicture = false;
        break;
    }
    this._cd.detectChanges();
  }

  seekThroughVideo(value) {
    // if (this.isSuperAdmin && this.isSliding === false)
    //   this._annotationService.getImageActive()

    // Updating picture number for the Canvas to update
    this.videoNumber = value;
    // console.log('animation seeking ', value);
    // Checking if picture is faved
    this.isSelected = this.favMatrix.isFaved(
      this.camName,
      this.toPictureName(value)
    );
    // Color the bubble if picture contains ROIs
    if (this.roisMatrix.pictureHasRois(this.camName, this.toPictureName(value))) {
      $('.slider').addClass('signalRoiPresent');
      // $('.signalRoi').removeAttr('hidden');
    } else {
      $('.slider').removeClass('signalRoiPresent');
      // $('.signalRoi').attr('hidden','true');
    }

  }

  isHover(event) {
    if (event.screenX > 190) this.hoverImg = 0;
    else this.hoverImg = 1;
  }

  // Set force to true or false to enforce that same value
  favThisPicture(force?: boolean, modalContent?: any) {
    let selectedValue = !this.isSelected;
    if (force === false) selectedValue = false;
    if (force === true) selectedValue = true;

    if ((this.gamma !== 1 || this.contrast !== 0 || this.saturation !== 0 || this.inversion !== false) && selectedValue) { // TODO: not gud
      this.favFiltersModalRef = this._modalService.open(this.favFiltersModal, { size: 'lg' });
      // Modal return value handler
      this.favFiltersModalRef.result.then((result) => {
        // console.log(`Closed with: ${result}`);
        this.favAccordingly(selectedValue, result);
      }, (reason) => {
        // console.log(`Dismissed ${reason}`);
      });
    } else {
      this.favAccordingly(selectedValue);
    }

    this._traceService.saveTrace(this.tchekId, 'set picture to favorite');
  }

  favAccordingly(selectedValue: boolean, saveFilters?: boolean) {
    /* Initializing filters with default values because filters cannot be stored as 'undefined' in the DB */
    let filters = {
      gamma: 1,
      contrast: 0,
      saturation: 0,
      inversion: false,
      mirror: false
    };
    let filters2 = {
      gamma: 1,
      contrast: 0,
      saturation: 0,
      inversion: false,
      mirror: false
    };
    if (this.comparisonActive) { // Duo picture fav
      if (saveFilters) {
        filters2 = {
          gamma: this.getCanvasParameter(this.cp.GAMMA, 1),
          contrast: this.getCanvasParameter(this.cp.CONTRAST, 1),
          saturation: this.getCanvasParameter(this.cp.SATURATION, 1),
          inversion: this.getCanvasParameter(this.cp.INVERSION, 1),
          mirror: this.getCanvasParameter(this.cp.MIRROR, 1)
        } as FavoritePictureFilters;
        filters = {
          gamma: this.getCanvasParameter(this.cp.GAMMA, 0),
          contrast: this.getCanvasParameter(this.cp.CONTRAST, 0),
          saturation: this.getCanvasParameter(this.cp.SATURATION, 0),
          inversion: this.getCanvasParameter(this.cp.INVERSION, 0),
          mirror: this.getCanvasParameter(this.cp.MIRROR, 0)
        } as FavoritePictureFilters;
      }
    } else { // Single picture fav
      // Populate filters if 'result' is true i.e. user wants to save filters
      if (saveFilters) {
        filters = {
          gamma: this.getCanvasParameter(this.cp.GAMMA, 0),
          contrast: this.getCanvasParameter(this.cp.CONTRAST, 0),
          saturation: this.getCanvasParameter(this.cp.SATURATION, 0),
          inversion: this.getCanvasParameter(this.cp.INVERSION, 0),
          mirror: this.getCanvasParameter(this.cp.MIRROR, 0)
        } as FavoritePictureFilters;
      }
      // console.log('selecting with filters ', filters);
      this._tchekService.favPicture(
        parseInt(this.toPictureName(this.routerNumberPic), 10),
        this.camName,
        this.tchekId,
        selectedValue,
        this.notif,
        filters
      ).then((picture) => {
        // console.log('fav single result', picture);
        // Update our local matrix without asking Parse again
        this.isSelected = picture.get('isSelected');
        if (this.isSelected)
          this.favMatrix.set(this.camName, this.toPictureName(this.routerNumberPic));
        else
          this.favMatrix.unset(this.camName, this.toPictureName(this.routerNumberPic));
      },
        () => console.error('Failed setting picture to favorites')
      );
    }
  }

  ngOnDestroy() {
    if (this.insideClassificationImage) {
      this.subscription.unsubscribe()
      this._subscriptionService.unsub("ImageClassification");
      this._subscriptionService.unsub("Images");
    }
  }

  changePOV(camera) {
    //console.log('angleChange', camera);
    this.isSelected = false;
    // Updating new selected camera value
    this.camName = camera.name;
    // Changing URL address
    this._location.go('/player/' + this.tchekId + '/' + camera.name + '/' + this.routerNumberPic);
    this.isPOVSeen[camera.name] = true;
    // Update the canvas
    // $('#animation-slider').trigger('mouseup');
  }

  angleChange(cameraName) {
    if (this.currentMode === 'video') {
      // console.log('angleChange', cameraName);
      this.selectedCompareDamage = undefined
      this.camName = '' + cameraName;
      // Changing URL address
      this._location.go('/player/' + this.tchekId + '/' + cameraName + '/' + this.routerNumberPic);
      this.isPOVSeen[cameraName] = true;
    } else {
      let index = this.tchek.images.indexOf(this.currentImage)
      index += parseInt(cameraName, 10);
      if (index < 0) index = 0
      if (index > this.tchek.images.length - 1) index = this.tchek.images.length - 1
      //      console.log(cameraName, index, 'change index')
      this.currentImage = this.tchek.images[index]
      this._location.go('/viewer/' + this.tchekId + '/' + this.currentImage.id);
    }
  }

  resetFilters() {
    this.gamma = 1;
    this.contrast = 0;
    this.saturation = 0;
    this.inversion = false;
    this.mirror = false;
    // Forcing view updates with jQuery
    $('#tweak-gamma').val(this.gamma);
    $('#tweak-contrast, #tweak-saturation').val(this.contrast);
    $('#tweak-invert').prop('checked', this.inversion);
    $('#tweak-mirror').prop('checked', this.mirror);

    // this.changeFiltersForAll();
  }

  verifWay() {
    if (this.revertCamera !== undefined) {
      return
    }
    this.revertCamera = false;
    this._tchekService.getTchek(this.tchekIdComparison).then(tchek2 => {
      console.log("revert ", this.tchek.way, tchek2.get('way'))
      if (this.tchek.way !== tchek2.get('way')) {
        this.revertCamera = true
      }
      this.reverseCamera()
    })
    this._damageService.getByTchek(this.tchekIdComparison).then(r => {
      this.tchekCompareDamages = r
    })
  }

  reverseCamera(): string {
    let number = parseInt(this.camName, 10)
    if (this.selectedCompareDamage)
      return this.selectedCompareDamage.roiPtr.folder
    if (this.revertCamera === undefined) {
      this.verifWay()
      return number.toString()
    }
    else if (this.revertCamera) {
      console.log('reverse camera : ', number);
      if (number === 13) { return '16' }
      else if (number === 14) { return '15' }
      else if (number === 15) { return '14' }
      else if (number === 16) { return '13' }
      else if (number < 4) { return (number + 9).toString() }
      else if (number > 9) { return (number - 9).toString() }
      else if (number < 7) { return (number + 3).toString() }
      else { return (number - 3).toString() }
    } else {
      return number.toString()
    }
  }


  generateCameras(way = true) {
    const orderCam = {
      '1': 6,
      '10': 11,
      '11': 9,
      '12': 7,
      '13': 13, //
      '14': 14, //
      '15': 15, // 
      '16': 16, //
      '2': 4,
      '3': 2,
      '4': 12,
      '5': 10,
      '6': 8,
      '7': 5,
      '8': 3,
      '9': 1
    };

    // Getting miniPicture links and totalPictures from parse.folders
    if (this.currentMode === 'video')
      this._tchekService.getFolder(this.tchekId).then(folders => {
        const deviceId = (this._parseFunction.getFolder(folders[0]).tchek.devicePtr.webObjectId
          ? this._parseFunction.getFolder(folders[0]).tchek.devicePtr.webObjectId
          : this._parseFunction.getFolder(folders[0]).tchek.devicePtr.id) + '/';
        const baseURLPicture = environment.finalBaseURL + deviceId;

        // Generating a Camera for each folder

        if (!this.isPercent) {
          folders.forEach(folder => {
            if (folder.get("name") == this.camName) {
              this.routerNumberPic = Math.floor(this.routerNumberPic * 100 / folder.get("totalPictures"))
              this.videoNumber = Math.floor(this.routerNumberPic * 100 / folder.get("totalPictures"))
            }
          });
          this.isPercent = true

        }

        this.countFolders = this.tchek.devicePtr.camNumber ? this.tchek.devicePtr.camNumber : 0

        folders.forEach(folder => {
          if (!this.tchek.devicePtr.camNumber)
            this.countFolders++
          folder = this._parseFunction.getFolder(folder);
          // TODO: Configure way behavior
          // folder.name = way ? folder.name : inverseCam(Number.parseInt(folder.name));
          // TODO: calculate relative number pic for each folder (o/w gives broken miniPictures when slider near the end)

          const relativePictureNumber = this.toPictureName(this.routerNumberPic, folder.totalPictures);
          // let relativeNumberPic = ;
          this.awsService.generateUrlPromise(
            deviceId +
            folder.tchek.path +
            '/mini/' +
            folder.name +
            '/' +
            relativePictureNumber + CanvasComponent._imageExtension, folder.tchek.devicePtr.ipMachine
          ).then(url => {
            this.listCamera.array.push(new Camera(folder.tchek.devicePtr.ipMachine, deviceId, folder.name, this.i18n({
              id: 'cam' + folder.name,
              value: 'Bas de caisse Arrière D.',
              description: 'Bas de caisse Arrière D.',
              meaning: 'Camera'
            }), orderCam[folder.name], folder.name, url, folder.totalPictures));

            // Sorting the cameras
            this.listCamera.sort();


            if (folder.name === this.camName) { // Otherwise could be undefined
              // $('input.slider').val((this.routerNumberPic / this.listCamera.atIndex(this.routerNumberPic).totalPictures) * 100);
              // this.isLoadingPicture = false;
            }
          });
        });

        // Setting bubble value
        $('input.slider').val(this.routerNumberPic);

        // Set POV as seen
        this.isPOVSeen[parseInt(this.camName, 10)] = true;

        // Checking if picture is faved
        this._tchekService.getAllFavPictures(this.tchekId).then(
          matrix => {
            this.favMatrix.favorites = matrix;
            // Checking if picture is faved for the initialization
            this.isSelected = this.favMatrix.isFaved(
              this.camName,
              this.toPictureName(this.routerNumberPic)
            );
          },
          error => console.error('Could not get favorites')
        );
      }, error => console.error('Could not get Tchek folders to initialize cameras\' miniPictures'));

  }

  regenerateCameras() {
    this.listCamera.array.forEach((camera, index) => {
      this.awsService.generateUrlPromise(
        camera.deviceId +
        '/' +
        this.diskFolderName +
        '/mini/' + camera.name +
        '/' +
        this.toPictureName(this.routerNumberPic, camera.totalPictures) +
        CanvasComponent._imageExtension, camera.ipMachine
      ).then(url => this.listCamera.setMiniPicture(camera.name, url));
    });
  }

  saveRoiProxy(event) {
    switch (this.canvasCurrentlyEditing) {
      case 1: this.canvas1.saveRoi(event); break;
      case 0: default: this.canvas0.saveRoi(event); break;
    }
  }

  editRoiProxy(event) {
    switch (this.canvasCurrentlyEditing) {
      case 1: this.canvas1.editRoi(event); break;
      case 0: default: this.canvas0.editRoi(event); break;
    }
  }

  cancelRoiProxy() {
    switch (this.canvasCurrentlyEditing) {
      case 1: this.canvas1.cancelRoi(); break;
      case 0: default: this.canvas0.cancelRoi(); break;
    }
  }

  cancelEditRoiProxy() {
    switch (this.canvasCurrentlyEditing) {
      case 1: this.canvas1.cancelEditRoi(); break;
      case 0: default: this.canvas0.cancelEditRoi(); break;
    }
  }

  switchtunnel() {
    this.tunnel = !this.tunnel
    this.awsService.changeTunnel(this.tunnel)
  }

  openComparison(tchekId: string) {
    this.tchekIdComparison = tchekId;
    // console.log('activating comparison with id ', tchekId);

    this.comparisonActive = true;
    $('#col-c1').css('display', 'default');
  }

  closeComparison(tchekId: string) {
    this.tchekIdComparison = tchekId;
    this._damageService.setComparison(false)
    // console.log('closing comparison with id ', tchekId);
    this.comparisonActive = false;
    this.activeCanvas = ActiveCanvas.LEFT;
    $('#col-c1').css('display', 'none');
  }

  toPictureName(picturePercent: number, totalPictures?: number): string {
    if (!totalPictures && !this.listCamera.get(this.camName))
      return
    // console.log('cam name ', this.camName, ' list ', this.listCamera, ' this camera ', this.listCamera.get(this.camName));
    const total = totalPictures !== undefined ? totalPictures : this.listCamera.get(this.camName).totalPictures;
    if (total === undefined)
      console.warn('Both argument totalPictures and listCamera.totalPictures are undefined');

    return (Math.floor((total / 100) * picturePercent)).toString();
    // Minus 1 to fix last image being blank
  }

  toggleEditMode(popover?: NgbPopover) {
    console.log('edit ')
    if (popover) {
      popover.close()
    }
    this.toggleAnnotate = false;
    this.toggleEdit = !this.toggleEdit;
  }

  toggleAnnotateMode(popover) {
    console.log('annotate ')
    this.toggleEdit = false;
    this.toggleAnnotate = !this.toggleAnnotate;
    if (this.toggleAnnotate && this.annotationMode === 0) {
      this.setDamageForAnnotation(this.listDamages[0])
    }
    if (this.toggleAnnotate && this.annotationMode === 1) {
      this.setPieceForAnnotation(this.listPieces[0])
    }
  }

  changeannotationModeType(value) {
    this.annotationMode = value
    if (this.toggleAnnotate && this.annotationMode === 0) {
      this.setDamageForAnnotation(this.listDamages[0])
    }
    if (this.toggleAnnotate && this.annotationMode === 1) {
      this.setPieceForAnnotation(this.listPieces[0])
    }

  }

  changeAnnoateMode(active) {
    console.log('change mode annotate : ', active);
    this.isImageHd = active
  }

  getRoiToEditWrapper() { return this._roiService.getRoiToEdit(); }

  setEditingCanvas(event) {
    this.canvasCurrentlyEditing = event;
  }

  setActiveCanvas(canvasId: number) {
    this.activeCanvas = canvasId;
  }

  setDamageForAnnotation(key) {
    // console.log($('#damageTypeSelected').val());
    console.log('change annotate  : ', key, this.listDamages[0]);
    this.canvas0.setDamageForAnnotation(key ? key : this.listDamages[0], 0);
  }
  setPieceForAnnotation(key) {
    // console.log($('#piecesTypeSelected').val());
    this.canvas0.setDamageForAnnotation(key ? key : this.listPieces[0], 1);
  }

  handleRequestExtractVideo(event) {
    this.clearTooltips();
    // console.log('requestedhd', event);
    event.preventDefault();
    event.stopPropagation();
    if (this.tchek && this.tchek.videoConverter !== 2 && this.tchek.videoConverter !== 1)
      this._tchekService.setExtractVideo(this.tchek.id).then(newTchek => {
        this.tchek = new TchekImages(newTchek, this.images[0].images);
        setTimeout(this.clearTooltips, 400);
      }, error => { });

  }

  handleRequestHdTchek(event) {
    this.clearTooltips();
    // console.log('requestedhd', event);
    event.preventDefault();
    event.stopPropagation();
    if (this.tchek &&
      (!this.tchek.uploadHDPictures
        || (this.tchek.uploadHDPictures && this.tchek.videoConverter === 2)))
      if (this.tchek.isHDLocal === false)
        this._toastService.toastOpen(undefined, this.i18n({
          id: 'deletedImage',
          value: 'Les images hd de ce scan ont été supprimées en local.',
          description: 'Les images hd de ce scan ont été supprimées en local.',
          meaning: "animation"
        }), 'error')
      else
        this._tchekService.setUploadHd(this.tchek.id).then(newTchek => {
          this.tchek = new TchekImages(newTchek, this.images[0].images);
          setTimeout(this.clearTooltips, 400);
        }, error => { });
  }
  handleRoiDrawerClick(damage) {
    if (this.isSuperAdmin)
      this._annotationService.getImageActive()
    this.canvas0.handleVideoSeeked();
  }

  handleDamageSelected(damage: DamageAnalysis) {
    if (this.isSuperAdmin)
      this._annotationService.getImageActive()
    this._roiService.setHighlightedDamage(damage)
    this.canvas0.addRoisToCanvas()


    // change offset of player comparaison to finish if decimation fail
    if (this.comparisonActive) {
      const numberVid = (typeof this.videoNumber === 'string' ? parseInt(this.videoNumber, 10) : this.videoNumber)
      let parent = damage.parentPtr.id
      if (parent && damage.isParentDamage) {
        let tchekParent = damage.parentPtr.tchekPtr.id
        console.log(this.tchekCompareDamages, parent);
        let index = this.tchekCompareDamages.findIndex(d => {
          if (d.parentPtr && d.parentPtr.id) return d.parentPtr.id === parent
          else return false
        })
        console.log('Scan parent Ptr : ', parent, ' index : ', index);
        this.selectedCompareDamage = this.tchekCompareDamages[index]
        this._roiService.setHighlightedDamageCompare(this.selectedCompareDamage)
        if ((index === -1 && damage.isParentDamage && this.tchekIdComparison !== tchekParent) || (index !== -1 && this.tchekIdComparison !== tchekParent)) {
          this._toastService.toastOpen(true, this.i18n({
            id: 'scanChange',
            value: 'Changement de Scan',
            description: 'Changement de Scan',
            meaning: "animation"
          }), 'error')
          this._tchekService.getTchek(tchekParent).then(tchek2 => {
            console.log("revert ", this.tchek.way, tchek2.get('way'))
            if (this.tchek.way !== tchek2.get('way')) {
              this.revertCamera = true
            }
            this.tchekIdComparison = tchekParent
            this._toastService.toastOpen(false, this.i18n({
              id: 'scanChange',
              value: 'Changement de Scan',
              description: 'Changement de Scan',
              meaning: "animation"
            }), 'error')
            this.reverseCamera()
          })
        }
      }
    }
  }

  handleDamageDeleted(damage: Damage) {
    /* this.roisMatrix.rois = this.roisMatrix.rois
      .filter(r => {
        if (r.get('damagePtr')){
        r.get('damagePtr').id !== damage.id}
      }); */
    var newRois = []
    this.roisMatrix.rois.forEach(r => {
      if (r.get('damagePtr')) {
        if (r.get('damagePtr').id !== damage.id) {
          newRois.push(r)
        }
      }
    });
    this.roisMatrix.rois = newRois
    this.canvas0.removeRoisByDamage(damage);
  }

  clearTooltips() {
    $('[data-toggle="tooltip"]').tooltip('dispose');
    $('.tooltip.fade.bs-tooltip-top.show').remove();
  }

  logoErrorHandler(event: any) {
    $(event.target).attr('src', this._defaultLogoPath);
  }

  traceCamera() {
    this.showCam = !this.showCam;
    this._traceService.saveTrace(
      this.tchekId,
      'single click cam in animation view'
    );
  }
}

// KeyCode of all keyboard keys and all browsers http://www.javascripter.net/faq/keycodes.htm



// WEBPACK FOOTER //
// ./src/app/animation/animation.component.ts